<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ titlePage }}</h1>
                </CCol>
                <CCol class="d-flex" md="1"> </CCol>
            </CRow>
            <!-- Title page  -->
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <!-- Filter -->
                <CRow class="justify-content-end p-2 mb-4">
                    <CCol md="6">
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
            </CContainer>
            <CContainer fluid>
                <CRow>
                    <CCol sm="12">
                        <CCard>
                            <CCardHeader>
                                <CCol md="1">
                                    <ButtonBack class="mr-3" title="Go back" />
                                </CCol>
                            </CCardHeader>
                            <CCardBody>
                                <CRow>
                                    <CCol xl="12" md="12">
                                        <CCard>
                                            <CCardHeader>
                                                <h4 class="mb-0">
                                                    {{
                                                        $t(
                                                            "Delivery campaign details"
                                                        )
                                                    }}
                                                </h4>
                                            </CCardHeader>
                                            <CCardBody>
                                                <CDataTable
                                                    :addTableClasses="[
                                                        'table--sm',
                                                    ]"
                                                    :items="
                                                        tables.deliveryCampaign
                                                            .items
                                                    "
                                                    :fields="
                                                        traslateArrayObjects({
                                                            array: tables
                                                                .deliveryCampaign
                                                                .fields,
                                                            fields: ['label'],
                                                        })
                                                    "
                                                    v-bind="
                                                        tables.deliveryCampaign
                                                    "
                                                >
                                                    <template #name="{ item }">
                                                        <td>
                                                            <span class="mr-2">
                                                                {{ item.name }}
                                                            </span>
                                                            <CBadge
                                                                color="warning"
                                                                class="
                                                                    text-white
                                                                "
                                                                v-c-tooltip="
                                                                    $t(
                                                                        'you_need_to_configure_a_webservice_to_send_the_data'
                                                                    ) + '.'
                                                                "
                                                                v-if="
                                                                    !item.wsRelation
                                                                "
                                                            >
                                                                <span>
                                                                    {{
                                                                        $t(
                                                                            "¡warning!"
                                                                        )
                                                                    }}
                                                                </span>
                                                            </CBadge>
                                                        </td>
                                                    </template>
                                                    <template
                                                        #active="{ item }"
                                                    >
                                                        <td>
                                                            <CBadge
                                                                v-if="
                                                                    stringToBoolean(
                                                                        item.active
                                                                    )
                                                                "
                                                                color="success"
                                                                class="mr-2"
                                                            >
                                                                {{
                                                                    $t("active")
                                                                }}
                                                            </CBadge>
                                                            <CBadge
                                                                v-else
                                                                color="secondary"
                                                                class="mr-2"
                                                            >
                                                                {{ $t("stop") }}
                                                            </CBadge>
                                                        </td>
                                                    </template>
                                                    <template
                                                        #ClientName="{ item }"
                                                    >
                                                        <td class="py-2">
                                                            <span
                                                                >{{
                                                                    item.ClientName
                                                                }}
                                                            </span>
                                                        </td>
                                                    </template>
                                                    <template
                                                        #dbRelation="{ item }"
                                                    >
                                                        <td class="py-2">
                                                            {{
                                                                item.dbRelation
                                                            }}
                                                        </td>
                                                    </template>
                                                    <template
                                                        #percent_ok="{ item }"
                                                    >
                                                        <td>
                                                            <ChartGauge
                                                                :value="
                                                                    item.percent_ok
                                                                "
                                                                size="sm"
                                                            />
                                                        </td>
                                                    </template>
                                                    <template
                                                        #percent_error="{
                                                            item,
                                                        }"
                                                    >
                                                        <td>
                                                            <ChartGauge
                                                                :value="
                                                                    item.percent_error
                                                                "
                                                                :reverse="true"
                                                                size="sm"
                                                            />
                                                        </td>
                                                    </template>
                                                    <template
                                                        #percent_ko="{ item }"
                                                    >
                                                        <td>
                                                            <ChartGauge
                                                                :value="
                                                                    item.percent_ko
                                                                "
                                                                :reverse="true"
                                                                size="sm"
                                                            />
                                                        </td>
                                                    </template>
                                                    <template
                                                        #percent_duplicate="{
                                                            item,
                                                        }"
                                                    >
                                                        <td>
                                                            <ChartGauge
                                                                :value="
                                                                    item.percent_duplicate
                                                                "
                                                                :reverse="true"
                                                                size="sm"
                                                            />
                                                        </td>
                                                    </template>

                                                    <template
                                                        #capping_ok="{ item }"
                                                    >
                                                        <td class="py-2">
                                                            <span>{{
                                                                item.capping_ok
                                                            }}</span>
                                                        </td>
                                                    </template>

                                                    <template
                                                        #created_at="{ item }"
                                                    >
                                                        <td class="py-2">
                                                            {{
                                                                item.created_at.split(
                                                                    " "
                                                                )[0]
                                                            }}
                                                        </td>
                                                    </template>
                                                </CDataTable>
                                            </CCardBody>
                                        </CCard>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol xl="12" md="12">
                                        <CCard>
                                            <CCardHeader>
                                                <CContainer :fluid="true">
                                                    <CRow>
                                                        <CCol sm="11">
                                                            <h4>
                                                                {{
                                                                    $t(
                                                                        "Breakdown Origin By Provider"
                                                                    )
                                                                }}
                                                            </h4>
                                                            <p class="mb-0">
                                                                {{
                                                                    $t(
                                                                        "The table below shows the number of shipments by each provider. Origins that do not have an associated provider are not counted"
                                                                    )
                                                                }}
                                                            </p>
                                                        </CCol>
                                                        <CCol sm="1">
                                                            <TableSettings
                                                                :allFields="
                                                                    tables
                                                                        .providers
                                                                        .allFields
                                                                "
                                                                :activeFields.sync="
                                                                    tables
                                                                        .providers
                                                                        .fields
                                                                "
                                                            />
                                                        </CCol>
                                                    </CRow>
                                                </CContainer>
                                            </CCardHeader>
                                            <CCardBody>
                                                <CDataTable
                                                    :addTableClasses="[
                                                        'table--sm',
                                                    ]"
                                                    :items="
                                                        tables.providers.items
                                                    "
                                                    :fields="
                                                        traslateArrayObjects({
                                                            array: tables
                                                                .providers
                                                                .fields,
                                                            fields: ['label'],
                                                        })
                                                    "
                                                    @update:column-filter-value="
                                                        updateData()
                                                    "
                                                    @update:sorter-value="
                                                        updateData()
                                                    "
                                                    :columnFilterValue.sync="
                                                        tables.providers
                                                            .columnFilterValue
                                                    "
                                                    :items-per-page="
                                                        tables.providers.rows
                                                    "
                                                    v-bind="tables.providers"
                                                >
                                                    <template #over-table>
                                                        <CContainer
                                                            :fluid="true"
                                                        >
                                                            <CRow
                                                                class="p-2 m-0"
                                                            >
                                                                <CCol
                                                                    md="12"
                                                                    sm="12"
                                                                >
                                                                    <!-- Filter -->
                                                                    <FilterFields
                                                                        :fields="
                                                                            tables
                                                                                .providers
                                                                                .fields
                                                                        "
                                                                        @filter="
                                                                            updateData
                                                                        "
                                                                    />
                                                                </CCol>
                                                            </CRow>
                                                        </CContainer>
                                                    </template>
                                                    <template #id="{ index }">
                                                        <td>{{ index + 1 }}</td>
                                                    </template>
                                                    <template #footer>
                                                        <tfoot>
                                                            <tr>
                                                                <td
                                                                    v-for="item in tables
                                                                        .providers
                                                                        .fields"
                                                                    :key="
                                                                        item.key
                                                                    "
                                                                >
                                                                    <span
                                                                        v-if="
                                                                            item.key ===
                                                                            'name'
                                                                        "
                                                                    >
                                                                        {{
                                                                            $t(
                                                                                "total"
                                                                            )
                                                                        }}
                                                                    </span>
                                                                    <span
                                                                        v-else-if="
                                                                            item.key !==
                                                                                'id' &&
                                                                            item.key !==
                                                                                'input'
                                                                        "
                                                                    >
                                                                        {{
                                                                            countTotal(
                                                                                tables
                                                                                    .providers
                                                                                    .itemsFiltered,
                                                                                [
                                                                                    item.key,
                                                                                ]
                                                                            )[
                                                                                item
                                                                                    .key
                                                                            ]
                                                                        }}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </tfoot>
                                                    </template>
                                                    <template #under-table>
                                                        <div
                                                            class="
                                                                d-flex
                                                                justify-content-end
                                                            "
                                                        >
                                                            <ButtonExport
                                                                :endPoint="
                                                                    '/campaigns.api/' +
                                                                    uuid +
                                                                    '/providers/stats'
                                                                "
                                                                :table="tables.providers"
                                                                :adapterFilters="adapterFiltersToUseDate"
                                                            />
                                                        </div>
                                                    </template>
                                                </CDataTable>
                                            </CCardBody>
                                        </CCard>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol xl="12" md="12">
                                        <CCard>
                                            <CCardHeader>
                                                <CContainer :fluid="true">
                                                    <CRow>
                                                        <CCol sm="11">
                                                            <h4>
                                                                {{
                                                                    $t(
                                                                        "Breakdown Dynamic String Origin"
                                                                    )
                                                                }}
                                                            </h4>
                                                            <p class="mb-0">
                                                                {{
                                                                    $t(
                                                                        "The table below shows the number of shipments by each origin"
                                                                    )
                                                                }}
                                                            </p>
                                                        </CCol>
                                                        <CCol sm="1">
                                                            <TableSettings
                                                                :allFields="
                                                                    tables
                                                                        .origins
                                                                        .allFields
                                                                "
                                                                :activeFields.sync="
                                                                    tables
                                                                        .origins
                                                                        .fields
                                                                "
                                                            />
                                                        </CCol>
                                                    </CRow>
                                                </CContainer>
                                            </CCardHeader>
                                            <CCardBody>
                                                <CDataTable
                                                    :addTableClasses="[
                                                        'table--sm',
                                                    ]"
                                                    :items="
                                                        tables.origins.items
                                                    "
                                                    :fields="
                                                        traslateArrayObjects({
                                                            array: tables
                                                                .origins.fields,
                                                            fields: ['label'],
                                                        })
                                                    "
                                                    @update:column-filter-value="
                                                        updateData()
                                                    "
                                                    @update:sorter-value="
                                                        updateData()
                                                    "
                                                    :columnFilterValue.sync="
                                                        tables.origins
                                                            .columnFilterValue
                                                    "
                                                    :items-per-page="
                                                        tables.origins.rows
                                                    "
                                                    v-bind="tables.origins"
                                                >
                                                    <template #id="{ index }">
                                                        <td>{{ index + 1 }}</td>
                                                    </template>
                                                    <template #over-table>
                                                        <CContainer
                                                            :fluid="true"
                                                        >
                                                            <CRow
                                                                class="p-2 m-0"
                                                            >
                                                                <CCol
                                                                    md="12"
                                                                    sm="12"
                                                                >
                                                                    <!-- Filter -->
                                                                    <FilterFields
                                                                        :fields="
                                                                            tables
                                                                                .origins
                                                                                .fields
                                                                        "
                                                                        @filter="
                                                                            updateData
                                                                        "
                                                                    />
                                                                </CCol>
                                                            </CRow>
                                                        </CContainer>
                                                    </template>
                                                    <template #footer>
                                                        <tfoot>
                                                            <tr>
                                                                <td
                                                                    v-for="item in tables
                                                                        .origins
                                                                        .fields"
                                                                    :key="
                                                                        item.key
                                                                    "
                                                                >
                                                                    <span
                                                                        v-if="
                                                                            item.key ===
                                                                            'origin'
                                                                        "
                                                                    >
                                                                        {{
                                                                            $t(
                                                                                "total"
                                                                            )
                                                                        }}
                                                                    </span>
                                                                    <span
                                                                        v-else-if="
                                                                            item.key !==
                                                                                'id' &&
                                                                            item.key !==
                                                                                'input' &&
                                                                            item.key !==
                                                                                'name'
                                                                        "
                                                                    >
                                                                        {{
                                                                            countTotal(
                                                                                tables
                                                                                    .origins
                                                                                    .itemsFiltered,
                                                                                [
                                                                                    item.key,
                                                                                ]
                                                                            )[
                                                                                item
                                                                                    .key
                                                                            ]
                                                                        }}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </tfoot>
                                                    </template>
                                                    <template #under-table>
                                                        <div
                                                            class="
                                                                d-flex
                                                                justify-content-end
                                                            "
                                                        >
                                                            <ButtonExport
                                                                :endPoint="
                                                                    '/campaigns.api/' +
                                                                    uuid +
                                                                    '/origins/stats'
                                                                "
                                                                :table="tables.origins"
                                                                :adapterFilters="adapterFiltersToUseDate"
                                                            />
                                                        </div>
                                                    </template>
                                                </CDataTable>
                                            </CCardBody>
                                        </CCard>
                                    </CCol>
                                </CRow>
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import FilterDate from "~/components/FilterDate";
import ChartGauge from "£lement/ChartGauge";
import ButtonBack from "£lement/ButtonBack";
import TableSettings from "£lement/TableSettings";
import ButtonExport from "~/components/ButtonExport";
import FilterFields from "~/components/FilterFields";
/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";

/** Others */
import {
    cilWarning,
    cilPlus,
    cilDataTransferDown,
    cilSettings,
    cilEnvelopeClosed,
} from "@coreui/icons";
import { mapGetters } from "vuex";
import { QueryBuilder } from "~/utils/queryBuilder.js";

export default {
    name: "DeliveryCampaignDetails",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        ChartGauge,
        ButtonBack,
        ButtonExport,
        TableSettings,
        FilterFields,
    },
    icons: {
        cilWarning,
        cilPlus,
        cilDataTransferDown,
        cilSettings,
        cilEnvelopeClosed,
    },
    directives: {
        export: {
            // Definición de directiva
            bind: function (el) {
                let table = el.querySelector("table");
                table.setAttribute("export", true);
            },
        },
    },
    data() {
        return {
            deliveryCampaign: null,
            tables: {
                providers: {
                    fields: [
                        {
                            key: "id",
                            label: "#",
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "name",
                            label: "name",
                            _filter: true,
                        },
                        {
                            key: "sent",
                            label: "sent",
                            _style: "width:15%",
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "ok",
                            label: "ok",
                            _style: "width:15%",
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "error",
                            label: "error",
                            _style: "width:15%",
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "ko",
                            label: "ko",
                            _style: "width:15%",
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "duplicate",
                            label: "duplicates",
                            _style: "width:15%",
                            filter: false,
                            _filter: false,
                        },
                    ],
                    items: [],
                    itemsFiltered: [],
                    order: "asc",
                    loading: true,
                    hover: true,
                    size: "sm",
                    responsive: true,
                    itemsFiltered: [],
                    allFields: [],
                    tableFilterValue: undefined,
                    sorter: {
                        external: true,
                        resetable: true,
                    },
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    columnFilterValue: {},
                },
                origins: {
                    fields: [
                        {
                            key: "id",
                            label: "#",
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "origin",
                            label: "origin",
                            filter: true,
                            _filter: true,
                        },
                        {
                            key: "name",
                            label: "provider",
                            filter: true,
                            _filter: true,
                        },
                        {
                            key: "sent",
                            label: "sent",
                            _style: "width:15%",
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "ok",
                            label: "ok",
                            _style: "width:15%",
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "error",
                            label: "error",
                            _style: "width:15%",
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "ko",
                            label: "ko",
                            _style: "width:15%",
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "duplicate",
                            label: "duplicates",
                            _style: "width:15%",
                            filter: false,
                            _filter: false,
                        },
                    ],
                    items: [],
                    itemsFiltered: [],
                    order: "asc",
                    loading: true,
                    hover: true,
                    size: "sm",
                    responsive: true,
                    itemsFiltered: [],
                    allFields: [],
                    tableFilterValue: undefined,
                    sorter: true,
                    sorter: {
                        external: true,
                        resetable: true,
                    },
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    columnFilterValue: {},
                },
                deliveryCampaign: {
                    fields: [
                        {
                            key: "ClientName",
                            label: "client",
                            sorter: true,
                            filter: false,
                            _filter: true,
                            _style: "width:15%",
                        },
                        {
                            key: "dbRelation",
                            label: "origin_db",
                            sorter: true,
                            filter: false,
                            _filter: false,
                            _style: "width:15%",
                        },
                        {
                            key: "spending",
                            label: "sale",
                            sorter: true,
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "sent",
                            label: "sent",
                            sorter: true,
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "ok",
                            label: "ok",
                            sorter: true,
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "percent_ok",
                            label: "ok_(%)",
                            sorter: true,
                            filter: false,
                            _style: "width:5%",
                            _filter: false,
                        },

                        {
                            key: "ko",
                            label: "ko",
                            sorter: true,
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "percent_ko",
                            label: "ko_(%)",
                            sorter: true,
                            filter: false,
                            _filter: false,
                            _style: "width:5%",
                        },
                        {
                            key: "duplicate",
                            label: "duplicates",
                            sorter: true,
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "percent_duplicate",
                            label: "duplicates_(%)",
                            sorter: true,
                            filter: false,
                            _filter: false,
                            _style: "width:5%",
                        },
                        {
                            key: "error",
                            label: "error",
                            sorter: true,
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "percent_error",
                            label: "error_(%)",
                            sorter: true,
                            filter: false,
                            _filter: false,
                            _style: "width:5%",
                        },
                        {
                            key: "created_at",
                            label: "created_at",
                            sorter: false,
                            filter: false,
                            _filter: false,
                            _style: "width:10%",
                        },
                    ],
                    items: [],
                    order: "asc",
                    loading: true,
                    hover: true,
                    size: "sm",
                    responsive: true,
                },
            },
        };
    },
    computed: {
        ...mapGetters({
            from: "filter/from",
            to: "filter/to",
        }),
        uuid: function () {
            return this.$route.params.uuid;
        },
        titlePage: function () {
            if (this.tables.deliveryCampaign.items.length > 0) {
                return this.tables.deliveryCampaign.items[0].name;
            } else return this.$t("Delivery campaign");
        },
        itemsWithTotal() {},
    },
    methods: {
        itemPerPage(newValue) {
            this.tables.providers.rows = newValue;
            this.updatePagination(this.tables.providers.page);
        },
        countTotal(items, fields = []) {
            let total = {};
            for (let i = 0; i < fields.length; i++) {
                const field = fields[i];
                total = {
                    ...total,
                    [field]: items.reduce(
                        (total, item) => total + parseInt(item[field]),
                        0
                    ),
                };
            }
            return total;
        },

        adapterFiltersToUseDate(query) {
            query = new QueryBuilder(query);
            query.createdAtToDate();
            return query.getQuery();
        },
        async updateData() {
            let detail = await this.fetcher({
                url: "/campaigns.api/stats",
                query: {
                    query: {
                        where: {
                            uuid: { equal: this.uuid },
                            created_at: {
                                between: [this.from, this.to, false],
                            },
                        },
                        order: { created_at: "asc" },
                    },
                },
            });
            this.tables.deliveryCampaign.items = this.normalizeArrayData({
                data: detail._items,
            });
            this.tables.deliveryCampaign.loading = false;
            await this.updateTable({
                tableName: "providers",
                url: `/campaigns.api/${this.uuid}/providers/stats`,
                adapterFilters: this.adapterFiltersToUseDate
            });
            await this.updateTable({
                tableName: "origins",
                url: `/campaigns.api/${this.uuid}/origins/stats`,
                adapterFilters: this.adapterFiltersToUseDate
            });
            this.updatePageLoading(false);
        },
        dbRelation(db_relation) {
            if (db_relation) {
                return db_relation.split("|")[0];
            } else {
                return "";
            }
        },
    },
    async mounted() {
        await this.updateData();
    },
};
</script>

<style  scoped lang="scss">
</style>